import { Control, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import { ExperimentStatus } from './constants';
import { Dispatch, SetStateAction } from 'react';
import { ErrorMessage } from '@cp/src/pages/auth/constants/AuthConstants';

export enum OrchestrationStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  IN_PROGRESS = 'IN_PROGRESS'
}
export interface AllocationExperiment {
  id: string;
  name: string;
  details: string;
  validEntityUri?: string;
  status: ExperimentStatus;
  validEntityCount: number;
  createdAt?: string;
  updatedAt?: string;
  createdBy: string;
  updatedBy?: string;
  orchestrationStatus: OrchestrationStatus;
  invalidEntityCount: number;
  errorReportUri?: string;
  originalFileUri?: string;
  originalFileName?: string;
}

export interface AllocationExperimentFormValues {
  name: string;
  details: string;
  status?: ExperimentStatus;
}

export interface IExperimentFormInput {
  control: Control<AllocationExperimentFormValues, any>;
  name: keyof AllocationExperimentFormValues;
  rules?: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AllocationExperimentFormValues>>;
  isEditDisabled?: boolean;
  inputLabel: string;
  placeholder: string;
  validationMessage: string;
  showRequiredIcon?: boolean;
  containerClass?: string;
}

export interface UploadExperimentFileProps {
  control: Control<AllocationExperimentFormValues, any>;
  name: keyof AllocationExperimentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AllocationExperimentFormValues>>;
  isEditDisabled?: boolean;
  styles: CSSModuleClasses;
  setSubmitButtonDisabled: (isDisabled: boolean) => void;
  inputLabel?: string;
  supportedFile?: string;
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
  setError: Dispatch<SetStateAction<ErrorMessage>>;
  setShowLoadingComponent: Dispatch<SetStateAction<boolean>>;
  showLoadingComponent?: boolean;
  error?: ErrorMessage;
  handleDownloadClick?: () => void;
  isEditPage?: boolean;
}

export interface ExperimentData {
  id: string;
  fileUrl: string;
  fileName: string;
  experimentName: string;
  experimentDetails: string;
}
